import { render, staticRenderFns } from "./customThird.vue?vue&type=template&id=0f2cbf98&scoped=true&"
import script from "./customThird.vue?vue&type=script&lang=ts&setup=true&"
export * from "./customThird.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./customThird.vue?vue&type=style&index=0&id=0f2cbf98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cbf98",
  null
  
)

export default component.exports